export default __webpack_public_path__ + "static/media/zawody1.9dfcdb07.jpg";